import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
// import VueI18n from 'vue-i18n';
import requests from '@/utils/newAxios'; // 导入axios拦截器
Vue.prototype.axios = requests; // 绑定拦截器
// import 'default-passive-events'; // 添加事件管理者’passive’，来阻止’touchstart’事件。解决chrome下的warning问题
// import { getProjectStatus } from '@/utils/vConsole'; // vConsole
import '@/utils/vConsole'; // vConsole
// import '@/utils/vConsole.min'; // vConsole
/** 导入图片预加载方法以及图片列表 */
import { imgsPreloader } from '@/utils/imgPreloader.js';
import imgPreloaderList from '@/utils/imgPreloaderList.js';
// Vant 支持一次性导入所有组件
import { Swipe, SwipeItem } from 'vant';
import 'vant/lib/index.css';
import Back from '@/plugins/Back';
import VueCropper from 'vue-cropper'; // 图片剪切
Vue.use(VueCropper);
Vue.use(Swipe);
Vue.use(SwipeItem);
// Vue.use(VueI18n);
Vue.component('Back', Back);

Vue.config.productionTip = false;
// const i18n = new VueI18n({
//     locale: localStorage.getItem('nissan_lang') || 'zh', // 从localStorage里获取用户中英文选择，没有则默认中文
//     messages: {
//         zh: require('@/lang/zh'),
//         en: require('@/lang/en')
//     }
// });
console.log('当前环境:' + process.env.NODE_ENV, '||', '后端地址:' + process.env.VUE_APP_SERVE);
// eslint-disable-next-line
// router.beforeEach(async (to, from, next) => {
//     getProjectStatus();
//     next();
// });
imgsPreloader(imgPreloaderList);
new Vue({
    router,
    // i18n,
    render: h => h(App)
}).$mount('#app');
